// src/app/features/auth/hooks/useLoginForm.ts
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiError } from '@vanialabs/core-api';
import { useAuthStore } from '@vanialabs/core-auth';
import { loginRepresentative } from '../api/login';
import { toAuthSession } from '../api/session.mapper';
import { toUserContexts } from '../api/userContext.mapper';
import { useUserContextStore } from '../state/userContext.store';

const GENERIC_ERROR_MESSAGE =
  'خطا در برقراری ارتباط با سرور. لطفاً دوباره تلاش کنید.';

/**
 * Extracts a Persian message from the backend's HTTPException body,
 * e.g. {"detail": "موبایل یا رمز عبور نادرست است."}.
 */
function extractErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const body = error.body as { detail?: unknown } | undefined;

    if (typeof body?.detail === 'string' && body.detail.trim()) {
      return body.detail;
    }
  }

  return GENERIC_ERROR_MESSAGE;
}

export function useLoginForm() {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const setSession = useAuthStore((state) => state.setSession);
  const setContexts = useUserContextStore((state) => state.setContexts);
  const navigate = useNavigate();

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();

    if (isSubmitting) return;

    setErrorMessage(null);
    setIsSubmitting(true);

    try {
      const response = await loginRepresentative({
        mobile,
        password,
      });

      const session = toAuthSession(response);

      console.log('[LOGIN RESPONSE]', response);
      console.log('[LOGIN SESSION]', session);

      setSession(session);
      setContexts(toUserContexts(response));

      console.log('[STORE AFTER LOGIN]', useAuthStore.getState().session);

      navigate('/dashboard', {
        replace: true,
      });
    } catch (error) {
      setErrorMessage(extractErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  }

  return {
    mobile,
    setMobile,
    password,
    setPassword,
    isSubmitting,
    errorMessage,
    handleSubmit,
  };
}
